import { IKpData } from '../types/offer';
import { IPromotionsAnalyticsData } from '../types/tracking';

export function getPromotionsAnalyticsData(
  offerId: number,
  kp?: IKpData | null,
): IPromotionsAnalyticsData {
  return {
    offerId,
    villageId: kp ? kp.id : null,
  };
}
